import { gql } from "@/gql";

export const CALENDAR_APPOINTMENTS_QUERY = gql(`
  query CalendarAppointments($salonId: ID!, $filters: AppointmentFilterInput) {
    appointments(salonId: $salonId, filters: $filters) {
      edges {
        node {
          ...AppointmentList @unmask
        }
        cursor
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`);

export const CALENDAR_WORKERS_QUERY = gql(`
  query CalendarWorkers($salonId: ID!, $filters: WorkerFilterInput) {
    workers(salonId: $salonId, filters: $filters) {
      workers {
        ...WorkerWithUser @unmask
      }
    }
  }
`);
